import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, Sparkles } from 'lucide-react';
export function Hero() {
  return <section id="inicio" className="relative min-h-screen flex items-center justify-center pt-20 overflow-hidden" data-id="element-142">
      {/* Background Neon Blobs */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-neon-violet/20 rounded-full mix-blend-screen filter blur-[100px] animate-blob" data-id="element-143" />
      <div className="absolute top-1/3 right-1/4 w-96 h-96 bg-neon-green/20 rounded-full mix-blend-screen filter blur-[100px] animate-blob animation-delay-2000" data-id="element-144" />
      <div className="absolute bottom-1/4 left-1/2 w-96 h-96 bg-fuchsia-500/20 rounded-full mix-blend-screen filter blur-[100px] animate-blob animation-delay-4000" data-id="element-145" />

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative z-10 w-full grid lg:grid-cols-2 gap-12 items-center" data-id="element-146">
        {/* Text Content */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="flex flex-col items-start text-left" data-id="element-147">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-white/5 border border-white/10 backdrop-blur-sm mb-6" data-id="element-148">
            <span className="w-2 h-2 rounded-full bg-neon-green animate-pulse" data-id="element-149" />
            <span className="text-xs font-semibold tracking-widest uppercase text-gray-300" data-id="element-150">
              Barbería Ninja 2.0
            </span>
          </div>

          <h1 className="font-display text-6xl md:text-8xl lg:text-9xl leading-[0.85] tracking-tight mb-6" data-id="element-151">
            Elevando el <br data-id="element-152" />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-neon-violet via-fuchsia-400 to-neon-green" data-id="element-153">
              Arte del Cabello
            </span>
            <br data-id="element-154" />
            al Siguiente Nivel.
          </h1>

          <p className="text-lg md:text-xl text-gray-400 max-w-xl mb-10 font-light leading-relaxed" data-id="element-155">
            Cortes de Autor, Colorimetría Avanzada y Formación para Barberos
            Profesionales por Nicolas Marshall.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 w-full sm:w-auto" data-id="element-156">
            <a href="#reservar" className="w-full sm:w-auto px-8 py-4 rounded-full bg-gradient-to-r from-neon-violet to-neon-green text-white font-semibold flex items-center justify-center gap-2 hover:scale-105 transition-transform duration-300 shadow-[0_0_30px_rgba(168,85,247,0.3)]" data-id="element-157">
              Agendar Reserva
              <ArrowRight size={18} data-id="element-158" />
            </a>
            <a href="#academia" className="w-full sm:w-auto px-8 py-4 rounded-full bg-white/5 border border-white/20 text-white font-semibold flex items-center justify-center gap-2 hover:bg-white/10 transition-colors duration-300 backdrop-blur-sm" data-id="element-159">
              Ver Cursos
              <Sparkles size={18} className="text-neon-green" data-id="element-160" />
            </a>
          </div>
        </motion.div>

        {/* Hero Visual */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 1,
        delay: 0.2
      }} className="relative hidden lg:block" data-id="element-161">
          <div className="relative w-full aspect-[4/5] rounded-3xl overflow-hidden border border-white/10" data-id="element-162">
            <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-transparent z-10" data-id="element-163" />
            <img src="https://cdn.magicpatterns.com/uploads/ep8bPYbkfJpGEktd3tLMCx/El_amor_al_arte_no_se_explica…_se_siente.Cada_linea,_cada_seccion,_cada_detalle_en_este_corte_ha.jpg" alt="Barbería Ninja 2.0" className="w-full h-full object-cover object-center" data-id="element-164" />

            {/* Floating Badge */}
            <motion.div animate={{
            y: [0, -10, 0]
          }} transition={{
            repeat: Infinity,
            duration: 4,
            ease: 'easeInOut'
          }} className="absolute bottom-10 -left-10 z-20 bg-[#0a0a0a]/80 backdrop-blur-xl border border-white/10 p-4 rounded-2xl flex items-center gap-4 shadow-2xl" data-id="element-165">
              <div className="w-12 h-12 rounded-full bg-gradient-to-br from-neon-violet to-neon-green flex items-center justify-center" data-id="element-166">
                <Sparkles size={20} className="text-white" data-id="element-167" />
              </div>
              <div data-id="element-168">
                <p className="text-sm font-bold text-white" data-id="element-169">Especialista</p>
                <p className="text-xs text-neon-green" data-id="element-170">Colorimetría</p>
              </div>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}